import { createElement as d, useContext as w, useRef as N, Fragment as k } from "react";
import { h as _, E as C, c as O, w as b, T as x } from "./emotion-element-6a883da9.browser.esm.js";
import { T as Z, w as $ } from "./emotion-element-6a883da9.browser.esm.js";
import "../../../hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js";
import { insertStyles as E, registerStyles as S, getRegisteredStyles as D } from "../../utils/dist/emotion-utils.browser.esm.js";
import { serializeStyles as p } from "../../serialize/dist/emotion-serialize.browser.esm.js";
import { useInsertionEffectWithLayoutFallback as v, useInsertionEffectAlwaysWithSyncFallback as T } from "../../use-insertion-effect-with-fallbacks/dist/emotion-use-insertion-effect-with-fallbacks.browser.esm.js";
var z = {
  name: "@emotion/react",
  version: "11.10.6",
  main: "dist/emotion-react.cjs.js",
  module: "dist/emotion-react.esm.js",
  browser: {
    "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
  },
  exports: {
    ".": {
      module: {
        worker: "./dist/emotion-react.worker.esm.js",
        browser: "./dist/emotion-react.browser.esm.js",
        default: "./dist/emotion-react.esm.js"
      },
      default: "./dist/emotion-react.cjs.js"
    },
    "./jsx-runtime": {
      module: {
        worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
        browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
        default: "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
      },
      default: "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
    },
    "./_isolated-hnrs": {
      module: {
        worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
        browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
        default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
      },
      default: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
    },
    "./jsx-dev-runtime": {
      module: {
        worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
        browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
        default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
      },
      default: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
    },
    "./package.json": "./package.json",
    "./types/css-prop": "./types/css-prop.d.ts",
    "./macro": "./macro.js"
  },
  types: "types/index.d.ts",
  files: [
    "src",
    "dist",
    "jsx-runtime",
    "jsx-dev-runtime",
    "_isolated-hnrs",
    "types/*.d.ts",
    "macro.js",
    "macro.d.ts",
    "macro.js.flow"
  ],
  sideEffects: !1,
  author: "Emotion Contributors",
  license: "MIT",
  scripts: {
    "test:typescript": "dtslint types"
  },
  dependencies: {
    "@babel/runtime": "^7.18.3",
    "@emotion/babel-plugin": "^11.10.6",
    "@emotion/cache": "^11.10.5",
    "@emotion/serialize": "^1.1.1",
    "@emotion/use-insertion-effect-with-fallbacks": "^1.0.0",
    "@emotion/utils": "^1.2.0",
    "@emotion/weak-memoize": "^0.3.0",
    "hoist-non-react-statics": "^3.3.1"
  },
  peerDependencies: {
    react: ">=16.8.0"
  },
  peerDependenciesMeta: {
    "@types/react": {
      optional: !0
    }
  },
  devDependencies: {
    "@definitelytyped/dtslint": "0.0.112",
    "@emotion/css": "11.10.6",
    "@emotion/css-prettifier": "1.1.1",
    "@emotion/server": "11.10.0",
    "@emotion/styled": "11.10.6",
    "html-tag-names": "^1.1.2",
    react: "16.14.0",
    "svg-tag-names": "^1.1.1",
    typescript: "^4.5.5"
  },
  repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
  publishConfig: {
    access: "public"
  },
  "umd:main": "dist/emotion-react.umd.min.js",
  preconstruct: {
    entrypoints: [
      "./index.js",
      "./jsx-runtime.js",
      "./jsx-dev-runtime.js",
      "./_isolated-hnrs.js"
    ],
    umdName: "emotionReact",
    exports: {
      envConditions: [
        "browser",
        "worker"
      ],
      extra: {
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": "./macro.js"
      }
    }
  }
}, J = function(e, t) {
  var r = arguments;
  if (t == null || !_.call(t, "css"))
    return d.apply(void 0, r);
  var o = r.length, n = new Array(o);
  n[0] = C, n[1] = O(e, t);
  for (var s = 2; s < o; s++)
    n[s] = r[s];
  return d.apply(null, n);
}, h = !1, A = /* @__PURE__ */ b(function(i, e) {
  process.env.NODE_ENV !== "production" && !h && (i.className || i.css) && (console.error("It looks like you're using the css prop on Global, did you mean to use the styles prop instead?"), h = !0);
  var t = i.styles, r = p([t], void 0, w(x)), o = N();
  return v(function() {
    var n = e.key + "-global", s = new e.sheet.constructor({
      key: n,
      nonce: e.sheet.nonce,
      container: e.sheet.container,
      speedy: e.sheet.isSpeedy
    }), a = !1, l = document.querySelector('style[data-emotion="' + n + " " + r.name + '"]');
    return e.sheet.tags.length && (s.before = e.sheet.tags[0]), l !== null && (a = !0, l.setAttribute("data-emotion", n), s.hydrate([l])), o.current = [s, a], function() {
      s.flush();
    };
  }, [e]), v(function() {
    var n = o.current, s = n[0], a = n[1];
    if (a) {
      n[1] = !1;
      return;
    }
    if (r.next !== void 0 && E(e, r.next, !0), s.tags.length) {
      var l = s.tags[s.tags.length - 1].nextElementSibling;
      s.before = l, s.flush();
    }
    e.insert("", r, s, !1);
  }, [e, r.name]), null;
});
process.env.NODE_ENV !== "production" && (A.displayName = "EmotionGlobal");
function R() {
  for (var i = arguments.length, e = new Array(i), t = 0; t < i; t++)
    e[t] = arguments[t];
  return p(e);
}
var Q = function() {
  var e = R.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, I = function i(e) {
  for (var t = e.length, r = 0, o = ""; r < t; r++) {
    var n = e[r];
    if (n != null) {
      var s = void 0;
      switch (typeof n) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(n))
            s = i(n);
          else {
            process.env.NODE_ENV !== "production" && n.styles !== void 0 && n.name !== void 0 && console.error("You have passed styles created with `css` from `@emotion/react` package to the `cx`.\n`cx` is meant to compose class names (strings) so you should convert those styles to a class name by passing them to the `css` received from <ClassNames/> component."), s = "";
            for (var a in n)
              n[a] && a && (s && (s += " "), s += a);
          }
          break;
        }
        default:
          s = n;
      }
      s && (o && (o += " "), o += s);
    }
  }
  return o;
};
function V(i, e, t) {
  var r = [], o = D(i, r, t);
  return r.length < 2 ? t : o + e(r);
}
var M = function(e) {
  var t = e.cache, r = e.serializedArr;
  return T(function() {
    for (var o = 0; o < r.length; o++)
      E(t, r[o], !1);
  }), null;
}, F = /* @__PURE__ */ b(function(i, e) {
  var t = !1, r = [], o = function() {
    if (t && process.env.NODE_ENV !== "production")
      throw new Error("css can only be used during render");
    for (var u = arguments.length, c = new Array(u), m = 0; m < u; m++)
      c[m] = arguments[m];
    var f = p(c, e.registered);
    return r.push(f), S(e, f, !1), e.key + "-" + f.name;
  }, n = function() {
    if (t && process.env.NODE_ENV !== "production")
      throw new Error("cx can only be used during render");
    for (var u = arguments.length, c = new Array(u), m = 0; m < u; m++)
      c[m] = arguments[m];
    return V(e.registered, o, I(c));
  }, s = {
    css: o,
    cx: n,
    theme: w(x)
  }, a = i.children(s);
  return t = !0, /* @__PURE__ */ d(k, null, /* @__PURE__ */ d(M, {
    cache: e,
    serializedArr: r
  }), a);
});
process.env.NODE_ENV !== "production" && (F.displayName = "EmotionClassNames");
if (process.env.NODE_ENV !== "production") {
  var j = !0, G = typeof jest < "u" || typeof vi < "u";
  if (j && !G) {
    var y = typeof globalThis < "u" ? globalThis : j ? window : global, g = "__EMOTION_REACT_" + z.version.split(".")[0] + "__";
    y[g] && console.warn("You are loading @emotion/react when it is already loaded. Running multiple instances may cause problems. This can happen if multiple versions are used, or if multiple builds of the same version are used."), y[g] = !0;
  }
}
export {
  F as ClassNames,
  A as Global,
  Z as ThemeContext,
  J as createElement,
  R as css,
  J as jsx,
  Q as keyframes,
  $ as withEmotionCache
};
//# sourceMappingURL=emotion-react.browser.esm.js.map
